const user = state => state?.common.user ?? dynamicValues.userProfile

export { user }
